import DevicePage from './page';
import { RouterConfig } from 'router/AppRoute';
import paths from 'helper/pathRoutes';

const routes: RouterConfig[] = [
  {
    path: paths.device,
    page: DevicePage,
  },
];

export default routes;
